/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { QuickMenuShortcut } from 'client-code/homeshortcut';

import { TIVO_SERVICES } from '../../config';
import { DeviceFeatures, DeviceModel } from '../device';
import { Services } from '../infrastructure';
import { QuickMenuShortcutService } from '../infrastructure/QuickMenuShortcutService';
import { ServicesClientImpl } from './ServicesClientImpl';

export class QuickMenuShortcutInteractor extends ServicesClientImpl {
    // eslint-disable-next-line class-methods-use-this
    private getQuickMenuShortcutParams() {
        return {
            accessToken: DeviceModel.getAccessToken(),
            bodyId: DeviceModel.getTiVoSettings().getBodyId(),
            basePath: ServicesClientImpl.servicesBaseUrls[TIVO_SERVICES.QuickMenuShortcut],
            timeZoneName: DeviceModel.getTVProperties().getDefaultTimeZone(),
        };
    }

    // eslint-disable-next-line class-methods-use-this
    public getQuickMenuShortcuts(): Promise<QuickMenuShortcut[]> {
        return Services.getInstanceOf(QuickMenuShortcutService, {
            ...this.getQuickMenuShortcutParams(),
            whiny: DeviceFeatures.isWhinyLoggingEnabled().toString(),
        }).getQuickMenuShortcuts();
    }

    // eslint-disable-next-line class-methods-use-this
    public getDefaultQuickMenuShortcuts(): Array<QuickMenuShortcut> {
        return Services.getInstanceOf(
            QuickMenuShortcutService,
            this.getQuickMenuShortcutParams(),
        ).getDefaultQuickMenuShortcuts();
    }

    // eslint-disable-next-line class-methods-use-this
    public getCachedQuickMenuShortcuts(): Array<QuickMenuShortcut> {
        return Services.getInstanceOf(
            QuickMenuShortcutService,
            this.getQuickMenuShortcutParams(),
        ).getCachedQuickMenuShortcuts();
    }

    // eslint-disable-next-line class-methods-use-this
    public fetchQuickMenuShortcutsWithFallback(): Promise<QuickMenuShortcut[]> {
        return Services.getInstanceOf(QuickMenuShortcutService, {
            ...this.getQuickMenuShortcutParams(),
            whiny: DeviceFeatures.isWhinyLoggingEnabled().toString(),
        }).fetchQuickMenuShortcutsWithFallback();
    }

    // eslint-disable-next-line class-methods-use-this
    public addIconUrlsToShortcuts(
        quickMenuShortcut: Array<QuickMenuShortcut>,
        shortcutIconList: Array<{
            iconName: string;
            iconClass: { highlighted: string; unhighlighted: string };
            isDisabled: boolean;
        }>,
    ): Array<QuickMenuShortcut> {
        return quickMenuShortcut.map((shortcut) => {
            const matchingIcon = shortcutIconList.find((icon) => icon.iconName === shortcut.title);
            return matchingIcon
                ? {
                      ...shortcut,
                      iconClass: matchingIcon.iconClass,
                      isDisabled: matchingIcon.isDisabled,
                  }
                : shortcut;
        });
    }
}
